import { AbstractModel, isNullOrUndefined } from '@uzurv/core';
import { inheritSerialization, autoserialize, autoserializeAs } from 'cerialize';

@inheritSerialization(AbstractModel)
export class OperatingSchedule extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserialize
  startTime: string;

  @autoserialize
  endTime: string;

  @autoserialize
  dayOfWeek: string;

  @autoserialize
  operational: boolean;

  constructor(init?: Partial<OperatingSchedule>) {
    super();
    Object.assign(this, init);
  }

  static OnSerialized(instance: OperatingSchedule, json: any): void {
    super.OnSerialized(instance, json);
    if (!isNullOrUndefined(instance.startTime)) {
      json.startTime = instance.startTime + ':00';
    }
    if (!isNullOrUndefined(instance.endTime)) {
      json.endTime = instance.endTime + ':00';
    }
  }

  static OnDeserialized(instance: OperatingSchedule, json: any): void {
    super.OnDeserialized(instance, json);
    if (!isNullOrUndefined(instance.startTime)) {
      instance.startTime = instance.startTime.substr(0, 5);
    }
    if (!isNullOrUndefined(instance.endTime)) {
      instance.endTime = instance.endTime.substr(0, 5);
    }
  }
}
